import InputFieldAmount from './InputFieldAmount';
import InputFieldDefault from './InputFieldDefault';
import InputFieldMultiSelect from './InputFieldMultiSelect';
import InputFieldPeriod from './InputFieldPeriod';
import InputFieldSelect from './InputFieldSelect';
import InputFieldSwitch from './InputFieldSwitch';
import InputFieldScoring from './InputFieldScoring';

const InputField = (props) => {
    const { config, onChange, defaultValue } = props;
    return (
        <>
            {
                (
                    !config.type ||
                    [
                        'text', 'password', 'email', 'color',
                        'date', 'month', 'range',
                        'tel', 'time', 'url', 'week'
                    ].indexOf(config.type) !== -1
                ) &&
                    <InputFieldDefault config={config} onChange={onChange} defaultValue={defaultValue} />
            }
            {
                config.type === 'number' &&
                <InputFieldAmount config={config} onChange={onChange} defaultValue={defaultValue} currency={false} />
            }
            {
                config.type === 'regex' &&
                <InputFieldScoring config={config} onChange={onChange} defaultValue={defaultValue} />
            }
            {
                config.type === 'amount' &&
                <InputFieldAmount config={config} onChange={onChange} defaultValue={defaultValue} />
            }
            {
                config.type === 'select' &&
                <InputFieldSelect config={config} onChange={onChange} defaultValue={defaultValue} />
            }
            {
                config.type === 'switch' &&
                <InputFieldSwitch config={config} onChange={onChange} defaultValue={defaultValue} />
            }
            {
                ['period', 'vintage'].indexOf(config.type) !== -1 &&
                <InputFieldPeriod config={config} onChange={onChange} defaultValue={defaultValue} />
            }
            {
                config.type === 'multi_select' &&
                <InputFieldMultiSelect
                    defaultValue={defaultValue}
                    className="me-0 w-200px"
                    config={{ ...config, multi: true }}
                    onChange={onChange} />
            }
        </>
    )
}

export default InputField
